import React from 'react'
import "./css/Product.css";
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';

function Product({ data }) {
  const [state, dispatch] = useStateValue();

  const addToBasket = () => {
    if (data?.productName && data?.productPrice && data?.productImage?.[0]) {
      dispatch({
        type: 'ADD_TO_BASKET',
        item: {
          title: data.productName,
          price: data.productPrice,
          image: data.productImage[0],
        }
      });
    } else {
      console.warn('Product data or required properties are null. Item not added to the basket.');
    }
  };
  return (
    <div className="product">
      <Link to={`/product-details/${data?.productName}`}>
        <img src={data?.productImage[0]} alt={data?.productName} />
      <div className="product_info">
        <p>{data?.productName}</p>
        <p className="product_price">
          <p>${data?.productPrice}</p>
        </p>
      </div>
      </Link>
      <button onClick={addToBasket}>Add to Cart</button>
    </div>
  )
}

export default Product